<template>
    <div>
        <PageTitle title="Inscrições Newsletter" />
        
        <b-table
            striped
            responsive
            hover
            :fields="table.headers"
            :items="table.records"
            :busy="loading"
        >
            
            <template #table-busy>
                <div class="text-center my-2">
                    <b-spinner class="align-middle mr-2"></b-spinner>
                    <strong>Carregando...</strong>
                </div>
            </template>

            <template #cell(name)="data">
                {{ data.item.name }}
            </template>

            <template #cell(email)="data">
                {{ data.item.email }}
            </template>

            <template #cell(whatsapp)="data">
                {{ data.item.whatsapp }}
            </template>

            <template #cell(actions)="data">
                <div>
                    <b-button variant="danger" title="Deletar assinante(?)" v-if="isDelete == false" @click="isDelete = true">
                        <i class="fas fa-trash"></i>
                    </b-button>
                    <b-button variant="primary" title="Editar dados" v-if="isDelete == false" class="ml-2" @click="permissionForEdit(data.item)">
                        <i class="fas fa-edit"></i>
                    </b-button>
                </div>

                <div>
                    <b-button variant="danger" title="Deletar assinante" v-if="isDelete" @click="deleteSubscriber(data.item.id)">
                        <i class="fas fa-trash"></i>
                    </b-button>
                    <b-button variant="warning" title="Cancelar" class="ml-2" v-if="isDelete" @click="isDelete = false">
                        <i class="fas fa-ban"></i>
                    </b-button>
                </div>
            </template>
        </b-table>

        <b-modal
            no-close-on-backdrop
            centered
            hide-header
            size="md"
            hide-footer
            v-model="open"
        >
            <h4>Editar assinante</h4>
            <b-row class="mt-4">
                <b-col cols="6">
                    <b-label>Nome</b-label>
                    <b-input
                        v-model="fieldsEdit.name"
                        debounce="string"
                        :placeholder="namePlaceholder"
                    >
                    </b-input>
                </b-col>
                    
                <b-col cols="6">
                    <b-label>Whatsapp</b-label>
                    <b-input
                        v-model="fieldsEdit.whatsapp"
                        debounce="number"
                        :placeholder="whatsappPlaceholder"
                        v-mask="'(##) #####-####'"
                    >
                    </b-input>
                </b-col>

                <b-col>
                    <b-label>E-mail</b-label>
                    <b-input
                        v-model="fieldsEdit.email"
                        debounce="string"
                        :placeholder="mailPlaceholder"
                    >
                    </b-input>
                </b-col>
            </b-row>
            <div class="d-flex justify-content-between mt-5">
                <b-button variant="danger" @click="open = false">Cancelar</b-button>
                <b-button variant="success" @click="editSubscriber()">Salvar</b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import PageTitle from 'Components/PageTitle.vue';
import makeToast from '@/mixins/makeToast';
import { mapState } from 'vuex';

export default {
    components: {
    PageTitle
  },

  mixins: [makeToast],

  data() {
    return {
        loading: false,
        open: false,
        isDelete: false,
        namePlaceholder: "",
        mailPlaceholder: "",
        whatsappPlaceholder: "",
        table: {
            headers: [
                    {
                        key: 'index',
                        thClass: 'd-none',
                        tdClass: 'd-none',
                    },
                    {
                        key: 'name',
                        label: 'Nome',
                        thClass: 'text-center',
                        tdClass: 'text-center',
                    },
                    {
                        key: 'email',
                        label: 'E-mail',
                        thClass: 'text-center',
                        tdClass: 'text-center',
                    },
                    {
                        key: 'whatsapp',
                        label: 'Whatsapp',
                        thClass: 'text-center',
                        tdClass: 'text-center',
                    },
                    {
                        key: 'actions',
                        label: 'Ações',
                        thClass: 'text-center',
                        tdClass: 'text-center',
                    },
            ],
            records: []
        },
        fieldsEdit: {
            name: "",
            email: "",
            whatsapp: "",
            id: "",
        }
    }
  },

  computed: {
    ...mapState(['token', 'dadosUsuario']),
  },

  mounted() {
    this.getFormData();
  },

  methods: {
    getFormData() {
        this.loading = true;

        this.$store.dispatch('shopkeeper/getAllFormData', this.dadosUsuario.id)
        .then((res) => {
            this.table.records = res.data.data || [];
        }).catch(() => {
            this.makeToast('Ops!', 'Infelizmente ocorreu um erro, favor recarregar página novamente!', 'danger');
        }).finally(() => {
            this.loading = false;
        });
    },

    deleteSubscriber(id) {
        this.loading = true;

        this.$store.dispatch('shopkeeper/deleteSubsciberNewsletter', id)
        .catch(() => {
            this.makeToast('Ops!', 'Infelizmente ocorreu um erro ao tentar deletar inscrição, favor tentar novamente!', 'danger');
        }).finally(() => {
            this.loading = false;
            this.getFormData();
            this.makeToast('Sucesso!', 'Inscrição deletada com sucesso!', 'success');
        });
    },

    editSubscriber() {
        this.loading = true;
        
        this.fieldsEdit.name == "" ? this.fieldsEdit.name = this.namePlaceholder : this.fieldsEdit;
        this.fieldsEdit.email == "" ? this.fieldsEdit.email = this.mailPlaceholder : this.fieldsEdit;
        this.fieldsEdit.whatsapp == "" ? this.fieldsEdit.whatsapp = this.whatsappPlaceholder : this.fieldsEdit;

        this.$store.dispatch('shopkeeper/editSubsciberNewsletter', this.fieldsEdit)
        .catch(() => {
            this.makeToast('Ops!', 'Infelizmente ocorreu um erro ao tentar editar inscrito, favor tentar novamente!', 'danger');
        }).finally(() => {
            this.loading = false;
            this.open = false;
            this.getFormData();
            this.cleanForm();
            this.makeToast('Sucesso!', 'Inscrição editada com sucesso!', 'success');
        });
    },

    cleanForm() {
        this.fieldsEdit.name = "";
        this.fieldsEdit.whatsapp = "";
        this.fieldsEdit.email = "";
    },

    permissionForEdit(data) {
        this.open = true;

        if (this.fieldsEdit) {
            this.fieldsEdit.id = data.id;
            this.namePlaceholder = data.name;
            this.mailPlaceholder = data.email;
            this.whatsappPlaceholder = data.whatsapp;
            return;
        }
    }
  }
}
</script>